import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/macromill-designsystem/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import { firstViewItemWhite, overviewItem, overviewTitle, issueSolutionItems, caseCTAItem } from './MacromillDesignsystemItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import FooterCTA from 'components/common/FooterCTA'
import styles from 'components/cases/macromill-designsystem/MacromillDesignsystem.module.scss'

const MacromillDesignsystem = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <FooterCTA />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
  </>
  )
}

export default MacromillDesignsystem
